import {
    Box,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Badge,
    Button,
    Input,
    InputGroup,
    InputRightAddon,
    Flex,
    Icon,
    Text,
    TableContainer,
    useBreakpointValue,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { FiMonitor, FiArrowLeft, FiX, FiPlus, FiCornerUpLeft, FiTrash2 } from "react-icons/fi";
import { Textarea, Heading, VStack, HStack, Divider } from "@chakra-ui/react";
import { useState } from "react";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar";

const tickets = [
    { subject: "[Ticket#778899] How to withdraw?", user: "Alice Walker", status: "Answered", priority: "Medium", reply: "2 days ago" },
    { subject: "[Ticket#334455] Game rules update", user: "Bob Marley", status: "Answered", priority: "Low", reply: "5 days ago" },
];

const getPriorityColor = (priority) => (priority === "High" ? "red" : priority === "Medium" ? "orange" : "blue");

const ITEMS_PER_PAGE = 10;

const AnsweredTickets = () => {
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    const [selectedTicket, setSelectedTicket] = useState(null);
    const isMobile = useBreakpointValue({ base: true, md: false });

    const totalPages = Math.ceil(tickets.length / ITEMS_PER_PAGE);
    const data = tickets.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE);
    const SIDEBAR_WIDTH = "240px";

    const handleShowDetail = (ticket) => {
        setSelectedTicket(ticket);
    };

    const handleBack = () => {
        setSelectedTicket(null);
    };

    return (
        <>
            <Navbar />
            <Sidebar />
            <Box p={{ base: 4, md: 8 }} bg="gray.50" minH="100vh" mt="64px" ml={{ base: 0, md: SIDEBAR_WIDTH }}>
                {selectedTicket ? (
                    <Box maxW="1200px" mx="auto">
                        {/* Detail Header */}
                        <Flex justify="space-between" align="center" mb={6}>
                            <Heading size="md" color="#344767" fontWeight="600">Reply Ticket</Heading>
                            <Button
                                leftIcon={<FiArrowLeft />}
                                size="sm"
                                variant="outline"
                                borderColor="gray.300"
                                onClick={handleBack}
                                _hover={{ bg: "gray.100" }}
                            >
                                Back
                            </Button>
                        </Flex>

                        {/* Ticket Action Card */}
                        <Box bg="white" borderRadius="12px" p={6} boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.1)" mb={8}>
                            <Flex justify="space-between" align="center" mb={6} direction={{ base: "column", sm: "row" }} gap={4}>
                                <Flex align="center" gap={3}>
                                    <Badge
                                        colorScheme="purple"
                                        variant="outline"
                                        borderRadius="full"
                                        px={3}
                                        py={0.5}
                                        textTransform="none"
                                        fontSize="xs"
                                    >
                                        Answered
                                    </Badge>
                                    <Text fontWeight="700" color="#344767" fontSize="lg">
                                        {selectedTicket.subject}
                                    </Text>
                                </Flex>
                                <Button
                                    leftIcon={<FiX />}
                                    colorScheme="red"
                                    size="sm"
                                    borderRadius="6px"
                                >
                                    Close Ticket
                                </Button>
                            </Flex>

                            <Textarea
                                placeholder="Enter reply here"
                                minH="150px"
                                bg="white"
                                border="1px solid"
                                borderColor="gray.200"
                                borderRadius="8px"
                                mb={6}
                                _focus={{ borderColor: "blue.400", boxShadow: "0 0 0 1px #4299E1" }}
                            />

                            <Flex justify="space-between" align="stretch" direction={{ base: "column", md: "row" }} gap={4}>
                                <Button
                                    leftIcon={<FiPlus />}
                                    bg="#0f172a"
                                    color="white"
                                    _hover={{ bg: "#1e293b" }}
                                    borderRadius="6px"
                                    size="md"
                                    w={{ base: "100%", md: "auto" }}
                                >
                                    Add Attachment
                                </Button>
                                <Button
                                    leftIcon={<FiCornerUpLeft />}
                                    bg="#4c3cff"
                                    color="white"
                                    _hover={{ bg: "#3f31d4" }}
                                    borderRadius="6px"
                                    size="md"
                                    px={8}
                                    w={{ base: "100%", md: "auto" }}
                                >
                                    Reply
                                </Button>
                            </Flex>
                            <Text fontSize="xs" color="blue.400" mt={4}>
                                Max 5 files can be uploaded | Maximum upload size is 256MB | Allowed File Extensions: .jpg, .jpeg, .png, .pdf, .doc, .docx
                            </Text>
                        </Box>

                        {/* Message History Section */}
                        <VStack spacing={6} align="stretch">
                            {/* Staff Response (Yellow Border) */}
                            <Box bg="white" borderRadius="12px" p={6} boxShadow="0 2px 4px rgba(0,0,0,0.05)" border="1px solid" borderColor="orange.200">
                                <Flex direction={{ base: "column", md: "row" }}>
                                    <Box w={{ base: "100%", md: "200px" }} pr={{ base: 0, md: 6 }} mb={{ base: 4, md: 0 }} borderRight={{ base: "none", md: "1px solid" }} borderColor="gray.100" textAlign={{ base: "left", md: "right" }}>
                                        <Text fontWeight="700" color="#344767" fontSize="lg" mb={1}>Super Admin</Text>
                                        <Text color="gray.500" fontSize="sm" mb={4}>Staff</Text>
                                        <Button
                                            leftIcon={<FiTrash2 />}
                                            colorScheme="red"
                                            size="xs"
                                            variant="solid"
                                            px={4}
                                        >
                                            Delete
                                        </Button>
                                    </Box>
                                    <Box flex="1" pl={{ base: 0, md: 6 }}>
                                        <Text fontSize="sm" color="gray.700" fontWeight="700" mb={3}>
                                            Posted on Thursday, 27th July 2023 @ 05:45 am
                                        </Text>
                                        <Text fontSize="sm" color="gray.600" lineHeight="tall">
                                            Tempora expedita ad
                                        </Text>
                                    </Box>
                                </Flex>
                            </Box>

                            {/* User Message (Blue Border) */}
                            <Box bg="white" borderRadius="12px" p={6} boxShadow="0 2px 4px rgba(0,0,0,0.05)" border="1px solid" borderColor="blue.100">
                                <Flex direction={{ base: "column", md: "row" }}>
                                    <Box w={{ base: "100%", md: "200px" }} pr={{ base: 0, md: 6 }} mb={{ base: 4, md: 0 }} borderRight={{ base: "none", md: "1px solid" }} borderColor="gray.100" textAlign={{ base: "left", md: "right" }}>
                                        <Text fontWeight="700" color="#344767" fontSize="lg" mb={1}>{selectedTicket.user}</Text>
                                        <Text color="gray.500" fontSize="sm" mb={4}>@{selectedTicket.user}</Text>
                                        <Button
                                            leftIcon={<FiTrash2 />}
                                            colorScheme="red"
                                            size="xs"
                                            variant="solid"
                                            px={4}
                                        >
                                            Delete
                                        </Button>
                                    </Box>
                                    <Box flex="1" pl={{ base: 0, md: 6 }}>
                                        <Text fontSize="sm" color="gray.700" fontWeight="700" mb={3}>
                                            Posted on Thursday, 27th July 2023 @ 05:43 am
                                        </Text>
                                        <Text fontSize="sm" color="gray.600" lineHeight="tall">
                                            Similique ipsum dol
                                        </Text>
                                    </Box>
                                </Flex>
                            </Box>
                        </VStack>
                    </Box>
                ) : (
                    <>
                        <Flex mb={8} justify="space-between" align={{ base: "stretch", md: "center" }} direction={{ base: "column", md: "row" }} gap={4}>
                            <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="semibold" color="#1a202c">Answered Tickets</Text>
                            <InputGroup maxW={{ base: "100%", md: "300px" }} size="md">
                                <Input bg="white" placeholder="Search..." value={search} onChange={(e) => setSearch(e.target.value)} borderRight="none" _focus={{ borderColor: "#4f46e5", boxShadow: "none" }} />
                                <InputRightAddon bg="#4f46e5" cursor="pointer" _hover={{ bg: "#4338ca" }}>
                                    <Icon as={SearchIcon} color="white" />
                                </InputRightAddon>
                            </InputGroup>
                        </Flex>

                        {/* MOBILE CARD VIEW */}
                        {isMobile ? (
                            <VStack spacing={4} align="stretch">
                                {data.map((t, i) => (
                                    <Box
                                        key={i}
                                        bg="white"
                                        borderRadius="12px"
                                        p={4}
                                        boxShadow="0 2px 4px rgba(0, 0, 0, 0.05)"
                                        border="1px solid #e2e8f0"
                                    >
                                        <Flex justify="space-between" align="flex-start" mb={3}>
                                            <Text fontSize="sm" fontWeight="700" color="#1a202c">
                                                Subject
                                            </Text>
                                            <Text fontSize="sm" fontWeight="600" color="#3182ce" textAlign="right">
                                                {t.subject}
                                            </Text>
                                        </Flex>

                                        <Flex justify="space-between" py={2} borderTop="1px solid #e2e8f0">
                                            <Text fontSize="sm" fontWeight="700" color="#1a202c">
                                                Submitted By
                                            </Text>
                                            <Text fontSize="sm" fontWeight="500" color="#4a5568">
                                                {t.user}
                                            </Text>
                                        </Flex>

                                        <Flex justify="space-between" py={2} borderTop="1px solid #e2e8f0">
                                            <Text fontSize="sm" fontWeight="700" color="#1a202c">
                                                Status
                                            </Text>
                                            <Badge colorScheme="green" variant="solid" px={3} borderRadius="full" textTransform="none">
                                                Answered
                                            </Badge>
                                        </Flex>

                                        <Flex justify="space-between" py={2} borderTop="1px solid #e2e8f0">
                                            <Text fontSize="sm" fontWeight="700" color="#1a202c">
                                                Priority
                                            </Text>
                                            <Badge colorScheme={getPriorityColor(t.priority)} variant="outline" px={3} borderRadius="full" textTransform="none">
                                                {t.priority}
                                            </Badge>
                                        </Flex>

                                        <Flex justify="space-between" py={2} borderTop="1px solid #e2e8f0">
                                            <Text fontSize="sm" fontWeight="700" color="#1a202c">
                                                Last Reply
                                            </Text>
                                            <Text fontSize="sm" color="gray.500">
                                                {t.reply}
                                            </Text>
                                        </Flex>

                                        <Flex justify="space-between" pt={2} borderTop="1px solid #e2e8f0">
                                            <Text fontSize="sm" fontWeight="700" color="#1a202c">
                                                Action
                                            </Text>
                                            <Button
                                                size="sm"
                                                variant="outline"
                                                colorScheme="blue"
                                                leftIcon={<Icon as={FiMonitor} />}
                                                fontSize="xs"
                                                onClick={() => handleShowDetail(t)}
                                                px={4}
                                            >
                                                Details
                                            </Button>
                                        </Flex>
                                    </Box>
                                ))}
                            </VStack>
                        ) : (
                            /* DESKTOP TABLE VIEW */
                            <Box bg="white" borderRadius="lg" overflow="hidden" boxShadow="sm" border="1px solid #e2e8f0">
                                <TableContainer>
                                    <Table variant="simple">
                                        <Thead bg="#4f46e5">
                                            <Tr h="50px">
                                                <Th color="white" textTransform="none" borderTopLeftRadius="lg">Subject</Th>
                                                <Th color="white" textTransform="none">Submitted By</Th>
                                                <Th color="white" textTransform="none" textAlign="center">Status</Th>
                                                <Th color="white" textTransform="none" textAlign="center">Priority</Th>
                                                <Th color="white" textTransform="none">Last Reply</Th>
                                                <Th color="white" textTransform="none" textAlign="right" borderTopRightRadius="lg">Action</Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {data.map((t, i) => (
                                                <Tr key={i} _hover={{ bg: "gray.50" }}>
                                                    <Td fontWeight="600" color="#3182ce" fontSize="sm">{t.subject}</Td>
                                                    <Td fontWeight="500" fontSize="sm">{t.user}</Td>
                                                    <Td textAlign="center">
                                                        <Badge colorScheme="green" variant="solid" px={3} borderRadius="full" textTransform="none">Answered</Badge>
                                                    </Td>
                                                    <Td textAlign="center">
                                                        <Badge colorScheme={getPriorityColor(t.priority)} variant="outline" px={3} borderRadius="full" textTransform="none">{t.priority}</Badge>
                                                    </Td>
                                                    <Td color="gray.500" fontSize="sm">{t.reply}</Td>
                                                    <Td textAlign="right">
                                                        <Button
                                                            size="sm"
                                                            variant="outline"
                                                            colorScheme="blue"
                                                            leftIcon={<Icon as={FiMonitor} />}
                                                            fontSize="xs"
                                                            onClick={() => handleShowDetail(t)}
                                                        >
                                                            Details
                                                        </Button>
                                                    </Td>
                                                </Tr>
                                            ))}
                                        </Tbody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        )}
                    </>
                )}
            </Box>
        </>
    );
};

export default AnsweredTickets;
